<template>
  <ValidationObserver ref="validator">
    <form novalidate class="md-layout generic-form" @submit.prevent="validate">
      <div class="md-layout-item md-medium-size-100 md-size-100">
        <md-card>
          <md-card-content>
            <md-table v-fixedTableHeader>
              <md-table-row>
                <md-table-head>
                  Name
                  <md-field>
                    <md-icon class="md-icon-outlined">filter_alt</md-icon>
                    <label></label>
                    <md-input v-model="filters.name"></md-input>
                  </md-field>
                </md-table-head>
                <md-table-head>
                  Country
                  <country-select mdClearable v-model="filters.country_iso3"></country-select>
                </md-table-head>
                <md-table-head>
                  Emails offers
                  <md-field>
                    <md-input v-model="filters.offers_emails"></md-input>
                  </md-field>
                </md-table-head>
                <md-table-head>
                  Emails restrictions
                  <md-field>
                    <md-input v-model="filters.restriction_emails"></md-input>
                  </md-field>
                </md-table-head>
                <md-table-head>
                  Online Wavy Segments
                  <segment-select mdClearable v-model="filters.online_wavy_segment_id"></segment-select>
                </md-table-head>
                <md-table-head>
                  Offline Wavy Segments
                  <segment-select mdClearable v-model="filters.offline_wavy_segment_id"></segment-select>
                </md-table-head>
                <md-table-head>
                  Channel Offline
                  <channel-select mdClearable :online="false" v-model="filters.offline_channel_id"></channel-select>
                </md-table-head>
                <md-table-head>
                  Channel Online
                  <channel-select mdClearable :online="true" v-model="filters.online_channel_id"></channel-select>
                </md-table-head>
              </md-table-row>
              <agency-row v-for="(item, index) in filteredPage" :key="item.id" v-model="filteredPage[index]" ref="rows"></agency-row>
            </md-table>
          </md-card-content>
          <md-card-actions>
            <slot name="paginator">
              <pagination
                v-if="Array.isArray(this.filteredPage) && pagination.perPage < pagination.total"
                class="pagination-no-border pagination-primary"
                v-model="pagination.currentPage"
                @input="paginate"
                :per-page="pagination.perPage"
                :total="pagination.total"
              >
              </pagination>
            </slot>
            <md-button class="md-success" type="submit">Save</md-button>
          </md-card-actions>
        </md-card>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import Api from '../../../../openapi/src/api/AgencyApi.js'

import CountrySelect from '../../../../components/Inputs/CountrySelect.vue'
import SegmentSelect from '../../../../components/Inputs/SegmentSelect.vue'
import ChannelSelect from '../../../../components/Inputs/ChannelSelect.vue'
import Pagination from '@/components/Pagination.vue'
import AgencyRow from '@/pages/Backend/Pages/Agencies/AgencyRow'

import debounce from 'lodash/debounce'

const api = new Api()

export default {
  components: {
    AgencyRow,
    CountrySelect,
    ChannelSelect,
    SegmentSelect,
    Pagination,
  },
  data() {
    return {
      agencies: null,
      filtered: [],
      filteredPage: [],
      filters: {
        name: null,
        country_iso3: null,
        offers_emails: null,
        restriction_emails: null,
        online_wavy_segment_id: null,
        offline_wavy_segment_id: null,
        offline_channel_id: null,
        online_channel_id: null,
      },
      pagination: {
        perPage: 10,
        currentPage: 1,
        total: 0,
      },
    }
  },
  mounted() {
    api.getAgencies(this.$root.hotelId, (error, data) => {
      this.agencies = data
      this.filter()
    })
  },
  methods: {
    filter: debounce(
      function() {
        let agencies = this.agencies
        if (this.filters.name) {
          agencies = agencies.filter((a) => a.name.toUpperCase().match('.*' + this.filters.name.toUpperCase() + '.*'))
        }
        if (this.filters.restriction_emails) {
          agencies = agencies.filter((a) =>
            a.restriction_emails.some((e) => e.toUpperCase().match('.*' + this.filters.restriction_emails.toUpperCase() + '.*'))
          )
        }
        if (this.filters.offers_emails) {
          agencies = agencies.filter((a) =>
            a.offers_emails.some((e) => e.toUpperCase().match('.*' + this.filters.offers_emails.toUpperCase() + '.*'))
          )
        }
        if (this.filters.online_wavy_segment_id) {
          agencies = agencies.filter((a) => a.online_wavy_segment_id == this.filters.online_wavy_segment_id)
        }
        if (this.filters.offline_wavy_segment_id) {
          agencies = agencies.filter((a) => a.offline_wavy_segment_id == this.filters.offline_wavy_segment_id)
        }
        if (this.filters.online_channel_id) {
          agencies = agencies.filter((a) => a.online_channel_id == this.filters.online_channel_id)
        }
        if (this.filters.offline_channel_id) {
          agencies = agencies.filter((a) => a.offline_channel_id == this.filters.offline_channel_id)
        }
        if (this.filters.country_iso3) {
          agencies = agencies.filter((a) => a.country_iso3 == this.filters.country_iso3)
        }

        this.filtered = agencies
        this.pagination.currentPage = 1
        this.pagination.total = agencies.length
        this.paginate()
      },
      250,
      { leading: true }
    ),
    paginate: function(page) {
      let total = Array.isArray(this.filtered) ? this.filtered.length : 0
      let from = this.pagination.perPage * (this.pagination.currentPage - 1)
      let to = from + this.pagination.perPage
      if (total < to) {
        to = total
      }
      this.filteredPage = this.filtered.slice(from, to)
    },
    async validate() {
      const isValid = await this.$refs.validator.validate()

      if (isValid) return this.update()

      this.$notify({
        timeout: 2500,
        message: '<strong>Not saved</strong>. Please check your inputs',
        icon: 'check_box',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: 'danger',
      })
    },
    refreshAgencies() {
      this.agencies.forEach((element) => {
        const currentRef = this.$refs.rows.find((row) => element.id === row.value.id)

        if (currentRef) {
          this.refreshArray(element.restriction_emails, currentRef.value.restriction_emails)
          this.refreshArray(element.offers_emails, currentRef.value.offers_emails)
        }
      })
    },
    refreshArray(currentValue, newValue) {
      currentValue.splice(0, currentValue.length, ...newValue)
    },
    update() {
      this.refreshAgencies()

      api.updateAgencies(this.$root.hotelId, this.agencies, (error, data, response) => {
        if (!error) {
          this.agencies = data
          this.filter()
          this.$root.$emit('saved')
        }
      })
    },
  },
  watch: {
    filters: {
      deep: true,
      handler: function() {
        this.filter()
      },
    },
  },
}
</script>

<style lang="scss">
.md-table-head-container {
  height: fit-content;
  .md-table-head-label {
    height: fit-content;
  }
}
.table-agencies {
  .email-offers {
    .md-table-cell-container {
      max-width: 100% !important;
    }
  }
}
</style>
